var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon_share_svg__painted",
    fill: "#9E9E9E",
    d: "M16.783 15.91c-.722 0-1.368.284-1.862.73l-6.773-3.942c.047-.218.085-.437.085-.665 0-.228-.038-.446-.085-.665l6.697-3.904c.513.475 1.188.77 1.938.77a2.847 2.847 0 0 0 2.85-2.85 2.846 2.846 0 0 0-2.85-2.85 2.846 2.846 0 0 0-2.85 2.85c0 .227.038.446.086.664L7.32 9.953a2.837 2.837 0 0 0-1.938-.77 2.846 2.846 0 0 0-2.85 2.85 2.846 2.846 0 0 0 2.85 2.85c.75 0 1.425-.294 1.938-.77l6.764 3.953c-.047.2-.076.408-.076.617a2.777 2.777 0 0 0 2.774 2.774c1.53 0 2.774-1.244 2.774-2.774s-1.244-2.774-2.774-2.774z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c9f163d69df2c4026375b7359250aa54.svg";
export { ForwardRef as ReactComponent };